import { teamSaveAllActions } from "./TeamSaveAllActions";

const initialState = {
  saveAllLoading: false,
  saveAllData: "",
  saveAllError: "",
};

const TeamSaveAllReducer = (state = initialState, action) => {
  switch (action.type) {
    case teamSaveAllActions.TEAM_SAVEALL_LOADING:
      return {
        ...state,
        saveAllLoading: true,
      };
    case teamSaveAllActions.TEAM_SAVEALL_SUCCESS:
      return {
        ...state,
        saveAllData: action.payload,
      };
    case teamSaveAllActions.TEAM_SAVEALL_ERROR:
      return {
        ...state,
        saveAllError: action.payload,
      };
    default:
      return state;
  }
};

export default TeamSaveAllReducer;
